var login_form = ( function( $ ) {

	var $form = false;
	var $status = false;

	var _init = function() {
		$form = $( 'form.login-form' );
		$status = $form.find( '.status' );

		$form.on( 'submit', _login_submit_event );
	};

	var _login_submit_event = function( event ) {
		console.log( 'submit' );

		var username = $form.find( '.username' ).val();
		var password = $form.find( '.password' ).val();

		login( username, password );

		event.preventDefault();
	};

	var login = function( username, password ) {
		set_message( 'Signing in, please wait&hellip;' );

		var data = {
			action: 'login',
			username: username,
			password: password,
			login_nonce: ScriptData.login_nonce
		};

		$.post( ScriptData.ajaxurl, data, _login_ajax_response, 'json' );
	};

	var _login_ajax_response = function( response ) {
		set_message( response.message );

		if ( response.success ) {

			if ( response.redirect ) {
				document.location.href = response.redirect;
			} else {
				location.reload();
			}
		}
	};

	var set_message = function( message ) {
		$status.html( message );
	};

	$( document ).ready( _init );

	return {};

} )( jQuery );

module.exports = login_form;